import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  RentalCar: {
    pickUp: {
      locationname: '',
      address: '',
      logo: '',
      company: '',
      code: ''
    },
    dropOff: {
      locationname: '',
      address: '',
      logo: '',
      company: '',
      code: ''
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
